export default {
  login: {
    title: 'Login to mypage',
    double_check_text: 'Incorrect data. Please confirm that you entered correct data.',
    id_email: 'ID/email address',
    password: 'Password',
    password_display: 'Show password',
    password_no_display: 'Hide password',
    login: 'Login',
    keep_login_text: 'Keep login status',
    forgot_password_text: 'Forgot password',
    contact_us: 'Sign up here',
    asuene_service_outline: 'CO2 visualization cloud service "ASUENE"',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'GX/ESG Talent-Focused Recruitment Platform "ASUENE CAREER"',
    corporate_page: 'Corporate website',
    cross_use: {
      title: 'Decarbonization & ESG One-stop Solution',
      asuene_product: {
        banner_title: 'Comprehensive Carbon Accounting Platform',
        flag_text: 'CO2 Accounting Platform<span class="caution">※</span><br /><strong><small>No.</small>1</strong>',
        left_btn_label: 'REQUEST A DEMO',
        left_btn_link: 'https://asuene.com/us/form/free-demo',
        right_btn_label: 'DOWNLOAD DOCUMENTS',
        right_btn_link: 'https://asuene.com/us/form/contact',
      },
      footer_note: '* No.1 in Japan by Survey: Tokyo shoko research, Ltd. / Survey period: July 2024',
    },
  },
}
